import React from "react";
import { Switch, Space, Button, Table, Checkbox, Row, Col, Tooltip } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faEye, faClockRotateLeft, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { ProhibitedArea, FullHeightContainerLayout } from "components";
import CypressTestIds from "../../../cypress/CypressTestIds";

const { Column } = Table;

const SystemConnectionAwsS3List = ({ connectionList, onAddConnection, onViewConnection, onEditConnection, onActivateDeactivateConnection, onViewConnectionHistory, onDeleteConnection, permission }) => {
    if (!permission) {
        return <ProhibitedArea></ProhibitedArea>
    }

    return <Row style={{ flexDirection: "column", flexGrow: 1, height: "100%" }}>
        <Col span={24} style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <FullHeightContainerLayout
                showHeader={false}
                showFooter={true}
                content={
                    <Table size="small"
                        rowKey="connectionId"
                        dataSource={connectionList}
                        pagination={false}
                        scroll={{ y: "100vh" }}
                        className="container-height-100"
                        data-testid={CypressTestIds.SYSTEM_CONNECTION_AWS_S3_LIST_TABLE}>
                        <Column
                            width="6em"
                            render={(value, connection, index) => <>
                                <FontAwesomeIcon
                                    icon={faPencil}
                                    className={permission.canEdit ? "action-cursor text-blue-500" : "text-gray-400 opacity-45"}
                                    onClick={() => permission.canEdit ? onEditConnection(connection.connectionId) : null}
                                    data-testid={CypressTestIds.SYSTEM_CONNECTION_AWS_S3_LIST_EDIT_BUTTON}/>
                                <FontAwesomeIcon
                                    icon={faEye}
                                    className={permission.canView ? "action-cursor text-blue-500" : "text-gray-400 opacity-45"}
                                    onClick={() => permission.canView ? onViewConnection(connection.connectionId) : null}
                                    data-testid={CypressTestIds.SYSTEM_CONNECTION_AWS_S3_LIST_VIEW_BUTTON}/>
                                <FontAwesomeIcon
                                    icon={faClockRotateLeft}
                                    className={permission.canView ? "action-cursor text-blue-500" : "text-gray-400 opacity-45"}
                                    onClick={() => permission.canView ? onViewConnectionHistory(connection.connectionId) : null}
                                    data-testid={CypressTestIds.SYSTEM_CONNECTION_AWS_S3_LIST_HISTORY_BUTTON}/>
                            </>}
                        />
                        <Column
                            dataIndex="name"
                            title="Name"
                            ellipsis={{
                                showTitle: false,
                            }}
                            render={(value, connection, index) => <Tooltip placement="topLeft" title={value}>{value}</Tooltip>}
                        />
                        <Column
                            width="20%"
                            dataIndex="description"
                            title="Description"
                            ellipsis={{
                                showTitle: false,
                            }}
                            render={(value, connection, index) => <Tooltip placement="topLeft" title={value}>{value}</Tooltip>}
                        />
                        <Column
                            width="12%"
                            dataIndex="businessAreaCount"
                            title="Business Areas"
                            ellipsis={{
                                showTitle: false,
                            }}
                            render={(value, connection, index) => <Tooltip placement="topLeft" title={value || 0}>{value || 0}</Tooltip>}
                        />
                        <Column
                            width="15%"
                            dataIndex="createdDate"
                            title="Created Date"
                            ellipsis={{
                                showTitle: false,
                            }}
                            render={(value, connection, index) => <Tooltip placement="topLeft" title={value}>{value}</Tooltip>}
                        />
                        <Column
                            width="15%"
                            dataIndex="updatedDate"
                            title="Updated Date"
                            ellipsis={{
                                showTitle: false,
                            }}
                            render={(value, connection, index) => <Tooltip placement="topLeft" title={value}>{value}</Tooltip>}
                        />
                        <Column
                            width="10%"
                            dataIndex="active"
                            title={"Active"}
                            ellipsis={{
                                showTitle: false,
                            }}
                            render={(value, connection, index) => {
                                return <Switch checked={value} disabled={!permission.canEdit} onClick={(checked, event) => onActivateDeactivateConnection(connection, checked)}
                                data-testid={CypressTestIds.SYSTEM_CONNECTION_AWS_S3_LIST_ACTIVE_SWITCH}></Switch>;
                            }}
                        />
                        <Column
                            width="5%"
                            render={(value, connection, index) => {
                                return (
                                    <FontAwesomeIcon
                                        icon={faTrashCan}
                                        className={permission.canDelete ? "action-cursor text-blue-500" : "text-gray-400 opacity-45"}
                                        onClick={() => permission.canDelete ? onDeleteConnection(connection) : null}
                                        data-testid={CypressTestIds.SYSTEM_CONNECTION_AWS_S3_LIST_DELETE_BUTTON}/>
                                );
                            }}
                        />
                    </Table>}
                footer={
                    <Row className="table-footer-row">
                        <Col span={24} className="footer-right-column">
                            <Button type="primary"
                                disabled={!permission.canAdd}
                                onClick={onAddConnection}
                                data-testid={CypressTestIds.SYSTEM_CONNECTION_AWS_S3_LIST_ADD_BUTTON}>
                                <PlusOutlined /> Add Connection
                            </Button>
                        </Col>
                    </Row>}
                footerStyle={{ paddingTop: "1rem" }}>

            </FullHeightContainerLayout>
        </Col>
    </Row>
};

export default SystemConnectionAwsS3List;